import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import Dropzone from 'react-dropzone';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';

import PDFItem from './pdf-item';

import { connect } from 'react-redux';

import { submitForm } from 'redux/modules/journey-edit/effects';

import { closeModal } from 'redux/modules/shipper-order-documents/effects';
import { getShipperOrderIdDocumentsModalOpened } from 'redux/modules/shipper-order-documents/selectors';
import { getShipperOrder } from 'redux/modules/shipper-orders/selectors';

import { getShipperOrderDetailData } from 'redux/modules/shipper-order-detail/selectors';
import { getShipperOrderIntoJourneyById } from 'redux/modules/job-detail/selectors';

import { Modal, Button, Flexer, Radios } from '@ontruck/orc';
import { readFile, fileToObj } from 'utils/file';
import * as http from 'utils/http';
import config from 'config';

import style from './style.module.scss';

const t = {
  title: 'Upload shipper documents',
  submit: 'Save',
  cancel: 'Cancel',
  drag_and_drop: 'Arrastra aquí documentos en PDF o',
  upload_images: 'selecciona archivos de tu equipo',
  can_show: 'The driver can show the documentation into the DriverApp (free)',
  has_to_print: 'The driver has to print the documents',
  error: {
    uploading: 'We could not upload the file',
    max_size: 'Files should be less than 15MB in size',
    different_types: 'You can upload images or PDFs files',
    corrupt_file:
      'There was a problem uploading this file, try again and if the problem persist please contact with support',
  },
};

class DocumentsModal extends Component {
  constructor(props) {
    super(props);

    const { shipper_order } = this.props;
    const additional_documents = (shipper_order && shipper_order.additional_documents) || [];

    this.state = {
      error: false,
      needsToPrint: (additional_documents || []).some((file) => file.need_to_be_printed),
      filesById: (additional_documents || []).reduce(
        (acc, file) => ({ ...acc, [file.id]: { ...file } }),
        {}
      ),
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDeleteFile = this.onDeleteFile.bind(this);
    this.handleNeedsToPrint = this.handleNeedsToPrint.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  handleSubmit = async () => {
    const { closeModal: closeModalFn, shipperOrderId } = this.props;

    const { filesById } = this.state;
    const body = {
      additional_documents: Object.keys(filesById || {}) || [],
      need_to_be_printed: true,
    };
    try {
      await http.patch(
        `${config.API_URL}shipper_orders/${shipperOrderId}/additional_documents`,
        body
      );
      closeModalFn();
    } catch (e) {
      this.setState({ error: true });
    }
  };

  handleNeedsToPrint(e) {
    this.setState({ needsToPrint: e.target.value });
  }

  onDeleteFile(file) {
    this.setState((prevState) => {
      let newFilesById = prevState.filesById;
      delete newFilesById[file.id];

      return {
        filesById: newFilesById,
      };
    });
  }

  uploadFile = async (file) => {
    let res = false;
    try {
      const fileReaded = await readFile(file);
      const fileObj = fileToObj(file);
      const response = await http.post(`${config.API_URL}additional_documents/`, {
        content: fileReaded,
        file_name: file.name,
      });
      const { id } = await response;

      res = { ...fileObj, id };
      return res;
    } catch (e) {
      console.log(e);
    }
  };

  onDrop = async (acceptedFiles) => {
    try {
      const responses = await Promise.all(acceptedFiles.map((file) => this.uploadFile(file)));
      this.setState((prevState) => ({
        filesById: {
          ...prevState.filesById,
          ...(responses || []).reduce((acc, file) => ({ ...acc, [file.id]: file }), {}),
        },
      }));
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { closeModal } = this.props;

    const { error, needsToPrint, filesById } = this.state;

    const localClassName = {
      dropzone: classnames(style.dropzone, {
        [style.dropzoneError]: error,
      }),
    };

    const dataToPrint = [
      { value: 'false', label: t.can_show },
      { value: 'true', label: t.has_to_print },
    ];

    const files = Object.values(filesById || {}) || [];

    return (
      <Modal show={true} closeButton={false} size="L">
        <Dropzone
          className={localClassName.dropzone}
          activeClassName={style.dropzoneActive}
          rejectClassName={style.dropzoneReject}
          onDrop={this.onDrop}
        >
          {({ getRootProps, getInputProps }) => {
            return (
              <div {...getRootProps({ className: localClassName.dropzone })}>
                {files.length > 0 && (
                  <div className={style.filesContainer}>
                    {(files || []).map((file) => (
                      <PDFItem key={file.id} onDelete={this.onDeleteFile} file={file} />
                    ))}
                  </div>
                )}
                {files.length > 0 ? (
                  <Button nude>{t.upload_images}</Button>
                ) : (
                  <div>
                    <span className={style.dropzoneHelp}>{t && t.drag_and_drop}</span>
                    <span className={style.dropzoneHelpActive}>{t && t.let_it_go}</span>
                    <Button nude>{t && t.upload_images}</Button>
                  </div>
                )}

                {error && (
                  <div>
                    <span className={style.dropzoneErrorTitle}>{t && t.error.uploading}</span>
                    <span className={style.dropzoneErrorText}>{t && t.error.max_size}</span>
                    <span className={style.dropzoneErrorText}>{t && t.error.different_types}</span>
                  </div>
                )}
                <input {...getInputProps()} />
              </div>
            );
          }}
        </Dropzone>

        {false && (
          <Flexer.Parent mTop="M">
            <Flexer.Child>
              <Radios
                value={String(needsToPrint)}
                name="users"
                items={dataToPrint}
                onChange={this.handleNeedsToPrint}
              />
            </Flexer.Child>
          </Flexer.Parent>
        )}

        <Flexer.Parent mRight="S" mTop="M">
          <Flexer.Child>
            <Button onClick={this.handleSubmit}>{t.submit}</Button>
          </Flexer.Child>
          <Flexer.Child>
            <Button nude skin="dark" onClick={closeModal}>
              {t.cancel}
            </Button>
          </Flexer.Child>
        </Flexer.Parent>
      </Modal>
    );
  }
}

DocumentsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  journey: PropTypes.object,
  onSave: PropTypes.func,
};

DocumentsModal.defaultProps = {
  journey: {},
};

const actionCreators = {
  submitForm,
  closeModal,
};

export default injectIntl(
  connect((state) => {
    const shipperOrderId = getShipperOrderIdDocumentsModalOpened(state);

    const shipperOrderDetail = getShipperOrderDetailData(state);
    const shipperOrderJob = getShipperOrderIntoJourneyById(state, shipperOrderId);

    return {
      shipperOrderId: getShipperOrderIdDocumentsModalOpened(state),
      shipper_order: {
        ...(getShipperOrder(state, shipperOrderId) || {}),
        ...(shipperOrderDetail || {}),
        ...(shipperOrderJob || {}),
      },
    };
  }, actionCreators)(DocumentsModal)
);
